import { LongText } from '@dfl/mui-react-common';

const GroupNameCell = ({ name, isGroup }: { name: string; isGroup?: boolean }) => {
  return <LongText text={name} lineClamp={1} className={isGroup ? 'uppercase font-bold text-gray-600' : 'ml-6'} />;
};

export default GroupNameCell;
